export const PERMISSIONS_APPS = [
  {
    name: 'Dashboard',
    uuid: 'Dashboard',
    subApps: [],
    disabledCheckbox: true,
    disabledDropdown: true,
    isDropdown: true,
    actions: [{ name: 'VIEW', uuid: 'VIEW' }],
    checked: true,
  },
  {
    name: 'Menu Manager',
    uuid: 'Menu Manager',
    subApps: [],
    // uncomment it when api will allow display and handle menumenager apps/
    //   [{
    //     name: 'Revenue Centers',
    //     uuid: 'Revenue Centers',
    //     isDropdown: true,
    //     checked: false
    //   },
    //   {
    //     name: 'Items',
    //     uuid: 'Items',
    //     isDropdown: true,
    //     checked: false
    //   },
    //   {
    //     name: 'DisplayCategories',
    //     uuid: 'DisplayCategories',
    //     isDropdown: true,
    //     checked: false
    //   },
    //   {
    //     name: 'Reporting Categories',
    //     uuid: 'Reporting Categories',
    //     isDropdown: true,
    //     checked: false
    //   },
    //   {
    //     name: 'Modifier Groups',
    //     uuid: 'Modifier Groups',
    //     isDropdown: true,
    //     checked: false
    //   },
    //   {
    //     name: 'Price Levels',
    //     uuid: 'Price Levels',
    //     isDropdown: true,
    //     checked: false
    //   },
    // ],
    disabledCheckbox: false,
    disabledDropdown: false,
    // change isDropdown to false when uncomment above apps
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
      { name: 'EDIT/DELETE', uuid: 'EDIT/DELETE' },
    ],
    checked: false,
  },
  {
    name: 'Orders',
    uuid: 'Orders',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: false,
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
      { name: 'EDIT/REFUND', uuid: 'EDIT/REFUND' },
    ],
    checked: false,
  },
  {
    name: 'Status',
    uuid: 'Status',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: false,
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
      { name: 'CANCEL', uuid: 'CANCEL' },
    ],
    checked: false,
  },
  {
    name: 'Reports Only',
    uuid: 'Reports Only',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: true,
    isDropdown: true,
    actions: [{ name: 'VIEW', uuid: 'VIEW' }],
    checked: false,
  },
  {
    name: 'Reports & Exports',
    uuid: 'Reports & Exports',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: true,
    isDropdown: true,
    actions: [{ name: 'VIEW', uuid: 'VIEW' }],
    checked: false,
  },
  {
    name: 'Loyalty',
    uuid: 'Loyalty',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: false,
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
    ],
    checked: false,
  },
  {
    name: 'Device Manager',
    uuid: 'Device Manager',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: false,
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
      { name: 'EDIT/DELETE', uuid: 'EDIT/DELETE' },
    ],
    checked: false,
  },
  {
    name: 'Suites',
    uuid: 'Suites',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: false,
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
      { name: 'EDIT/DELETE', uuid: 'EDIT/DELETE' },
    ],
    checked: false,
  },
  {
    name: 'Access',
    uuid: 'Access',
    subApps: [],
    disabledCheckbox: false,
    disabledDropdown: false,
    isDropdown: true,
    actions: [
      { name: 'VIEW', uuid: 'VIEW' },
      { name: 'EDIT', uuid: 'EDIT' },
    ],
    checked: false,
  },
]
